import React from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'

import {
  footerLinks,
  socialLinks,
  footerNavigationLinks,
} from '../../../constants/links'
import useStyles from './styles'
import {
  Box,
  Typography,
  List,
  ListSubheader,
  ListItem,
} from '@material-ui/core'

const AvisoDePrivacidad = require('../../../assets/aviso.pdf')

const Footer = () => {
  const {
    footer,
    slogan,
    links,
    icons,
    copyright,
    sectionTitle,
    list,
    subheader,
    footerNavItem,
    footerNavItemLink,
    footerNavSection,
  } = useStyles()

  const internalLinks = footerLinks.filter((e) => !e.external)
  const externalLinks = footerLinks.filter((e) => e.external)

  return (
    <section>
      <Box className={footer}>
        <Typography className={slogan}>
          Tenemos más de 50 años de experiencia.
        </Typography>
        <List component="div" subheader={<div />} className={list}>
          {footerNavigationLinks.map(({ text, items }, i) => (
            <div key={i} className={footerNavSection}>
              <ListSubheader component="div" className={subheader}>
                <Typography variant="caption" className={sectionTitle}>
                  {text}
                </Typography>
              </ListSubheader>
              {items.map(({ text, path }, j) => (
                <ListItem key={j} className={footerNavItem}>
                  {path ? (
                    <AniLink fade to={path} className={footerNavItemLink}>
                      {text}
                    </AniLink>
                  ) : (
                    <span className={footerNavItemLink}>{text}</span>
                  )}
                </ListItem>
              ))}
            </div>
          ))}
        </List>
        <div className={links}>
          {externalLinks.map((item, index) => {
            return (
              <a
                key={index}
                href={item.path}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.text}
              </a>
            )
          })}
          {internalLinks.map((item, index) => {
            return (
              <AniLink key={index} fade to={item.path}>
                {item.text}
              </AniLink>
            )
          })}
          <a href={AvisoDePrivacidad} download>
            Aviso de privacidad
          </a>
        </div>
        <div className={icons}>
          {socialLinks.map((item, index) => {
            return (
              <a
                key={index}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.icon}
              </a>
            )
          })}
        </div>
        <div className={copyright}>
          Global Actuarial Services, S.C. {new Date().getFullYear()}
        </div>
      </Box>
    </section>
  )
}

export default Footer
